module.exports = __webpack_public_path__ + "img/abstract3.58864270.png";